export default {
    SET_IS_LOADING (state, isLoading){
        state.isLoading = isLoading
    },

    SET_IS_SHOW (state, isShow){
        state.isShow = isShow;
    },

    SET_IS_PRINT (state, isPrint){
        state.isPrint = isPrint;
    },

    SET_IS_PREVIEW (state, isPreview){
        state.isPreview = isPreview;
    },

    SET_IS_FIRST_LOADED (state, isFirstLoaded){
        state.isFirstLoaded = isFirstLoaded;
    },

    SET_DATETIME (state, datetime){
        state.dateTime.startDate = datetime.startDate;
        state.dateTime.endDate = datetime.endDate;
    },

    SET_POST_SPEND(state, data) {
        let post = state.ownPageData.posts.find(item => item.id === data.post_id);
        post.spend_amount = data.spend_amount;
        post.spent_out = data.spent_out;
    },

    SET_PAGES(state, response) {
        state.pages = [];
        state.competitorBenchmark.competitor_ids = [];

        response.data.resp.profiles.forEach((item) => {
            if (item.isOwn) {
                state.ownPage = item;
            } else {
                state.pages.push(item);
            }

            state.competitorBenchmark.competitor_ids.push(item.id);
        });
    },

    SET_OWN_PAGE(state, ownPage) {
        state.ownPage = ownPage;
    },

    UPDATE_BUDGET_SPEND(state, data) {
        state.ownPageData.budget_spend.value = data.value;
        state.ownPageData.budget_spend.percent = data.percent;
    },

    UPDATE_CPM(state, data) {
        state.ownPageData.cpm.value = data.value;
        state.ownPageData.cpm.diff = data.percent;
    },

    UPDATE_CPA(state, data) {
        state.ownPageData.cpa.value = data.value;
        state.ownPageData.cpa.diff = data.percent;
    },

    UPDATE_CTR(state, data) {
        state.ownPageData.ctr.value = data.value;
        state.ownPageData.ctr.diff = data.percent;
    },

    SET_APP_VERSION(state, version) {
        state.appVersion = version;
    },

    ADD_MY_APP(state, data) {
        state.myApps = data;
    },

    DELETE_MY_APP(state, id) {
        state.myApps = state.myApps.filter(myApp => myApp.id !== id);
    },

    FAVOURITE_MY_APP(state, data) {
        state.myApps = state.myApps.map((app) => {
            if (app.id === data.id) {
                app.favourite = data.favourite;
            }

            return app;
        });
    },

    SET_OWN_PAGE_POSTS(state, response) {
        state.ownPageData.posts = [];

        let type;

        response.data.resp.posts.forEach((post) => {

            if (post.type === 'photo') {
                type = '<i class="fab fa-instagram fa-1x text-black"></i>';
            }else {
                type = '<i class="fas fa-video fa-1x text-black"></i>'
            }

            state.ownPageData.posts.push({
                id: post.id,
                date: post.created_time,
                picture: post.picture,
                message: post.message,
                type: type,
                reach: post.processed_insights.post_impressions,
                reactions: post.reactionsStats.total,
                comments: post.commentsStats.total,
                shares: post.shares,
                engagement: post.engagement,
                people_reached: 0,
                spend_amount: 0,
                spent_out: 0,
            })
        });
    },

    SET_OWN_PAGE_DATA(state, response) {

        let data = response.data.resp[state.ownPage.id];

        state.ownPageData.engagement.value = data.kpis.engagement.current_period.abbr_string_2f;
        state.ownPageData.engagement.percent = data.kpis.engagement.diff_percent_value.string_2f;

        state.ownPageData.engagement_rate.value = data.kpis.engagement_rate_per_post.current_period.abbr_string_2f;
        state.ownPageData.engagement_rate.percent = data.kpis.engagement_rate_per_post.diff_percent_value.string_2f;

        state.ownPageData.comments.value = data.kpis.comments.current_period.string_2f;
        state.ownPageData.comments.percent = data.kpis.comments.diff_percent_value.string_2f;

        state.ownPageData.share.value = data.kpis.shares.current_period.string_2f;
        state.ownPageData.share.percent = data.kpis.shares.diff_percent_value.string_2f;

        state.ownPageData.reactions.value = data.kpis.reactions.current_period.string_2f;
        state.ownPageData.reactions.percent = data.kpis.reactions.diff_percent_value.string_2f;

        state.ownPageData.messages.value = data.kpis.page_messages_total_messaging_connections.current_period.string_2f;
        state.ownPageData.messages.percent = data.kpis.page_messages_total_messaging_connections.diff_percent_value.string_2f;

        state.ownPageData.reach.value = data.kpis.reach.current_period.abbr_string_2f;
        state.ownPageData.reach.percent = data.kpis.reach.diff_percent_value.string_2f;

        state.ownPageData.impression.value = data.kpis.impressions.current_period.abbr_string_2f;
        state.ownPageData.impression.percent = data.kpis.impressions.diff_percent_value.string_2f;

        state.ownPageData.paid_reach.value = data.kpis.page_posts_sum_paid_reach.current_period.string_2f;
        state.ownPageData.paid_reach.percent = data.kpis.page_posts_sum_paid_reach.diff_percent_value.string_2f;

        state.ownPageData.organic_reach.value = data.kpis.page_posts_sum_organic_reach.current_period.string_2f;
        state.ownPageData.organic_reach.percent = data.kpis.page_posts_sum_organic_reach.diff_percent_value.string_2f;

        state.ownPageData.fans_growth.value = data.kpis.fans_growth.current_period.value;
        state.ownPageData.fans_growth.diff = data.kpis.fans_growth.diff_percent_value.value;

        // Content Performance
        state.ownPageData.post.value = data.kpis.posts.current_period.value;
        state.ownPageData.post.percent = data.kpis.posts.diff_percent_value.string_2f;

        let post_by_photo = data.tables.posts_by_type_list.find(type => type.text === "photo");
        if (post_by_photo) {
            state.ownPageData.post_by_photo = post_by_photo.value;
        }else {
            state.ownPageData.post_by_photo = 0;
        }

        let post_by_video = data.tables.posts_by_type_list.find(type => type.text === "video");
        if (post_by_video) {
            state.ownPageData.post_by_video = post_by_video.value;
        }else {
            state.ownPageData.post_by_video = 0;
        }

        let reach_by_photo = data.tables.reach_by_type_list.find(type => type.text === "photo");
        if (reach_by_photo) {
            state.ownPageData.reach_by_photo = reach_by_photo.value;
        }else {
            state.ownPageData.reach_by_photo = 0;
        }

        let reach_by_video = data.tables.reach_by_type_list.find(type => type.text === "video");
        if (reach_by_video) {
            state.ownPageData.reach_by_video = reach_by_video.value
        }else {
            state.ownPageData.reach_by_video = 0;
        }

        state.ownPageData.engagement_by_photo = data.charts.fb_page_engagement_by_type.series[0].data[0];
        state.ownPageData.engagement_by_video = data.charts.fb_page_engagement_by_type.series[0].data[1];

        state.ownPageData.avg_reach_per_post.value = data.kpis.avg_reach.current_period.integer;
        state.ownPageData.avg_reach_per_post.value = data.kpis.avg_reach.diff_percent_value.abbr_string_2f;

        state.ownPageData.avg_engagement_rate.value = data.kpis.average_engagement_per_post.current_period.float_2f;
        state.ownPageData.avg_engagement_rate.percent = data.kpis.average_engagement_per_post.diff_percent_value.string_2f;

        state.ownPageData.post_engagement.value = data.kpis.engagement.current_period.string_2f;
        state.ownPageData.post_engagement.percent = data.kpis.engagement.diff_percent_value.string_2f;

        state.ownPageData.post_reach.value = data.kpis.reach.current_period.string_2f;
        state.ownPageData.post_reach.percent = data.kpis.reach.diff_percent_value.string_2f;

        state.ownPageData.video_view_time.value = data.kpis.video_view_time.current_period.string_2f;
        state.ownPageData.video_view_time.percent = data.kpis.video_view_time.diff_percent_value.string_2f;

        state.ownPageData.three_second_video_view.value = data.kpis.video_views.current_period.string_2f;
        state.ownPageData.three_second_video_view.percent = data.kpis.video_views.diff_percent_value.string_2f;
    },

    SET_COMPETITOR_BENCHMARK(state, response) {
        // Competitor Benchmark
        delete response.data.resp[state.ownPage.id];

        state.competitorBenchmark.competitors = [];

        Object.values(response.data.resp).forEach((page) => {
            state.competitorBenchmark.competitors.push({
                id: page.pageinfo.id,
                name: page.pageinfo.name,
                picture: page.pageinfo.picture,
                si_name: page.pageinfo.si_name,
                username: page.pageinfo.username,
                global_brand_page_name: page.pageinfo.global_brand_page_name,
                fans_2f: page.kpis.fans.current_period.abbr_string_2f,
                fans: page.kpis.fans.current_period.value,
                evolution: page.tables.posts_evolution.metadata.data_avg,
                engagement: page.kpis.engagement.current_period.value,
                posts: page.kpis.posts.current_period.value,
                engagement_rate_par_post: page.kpis.engagement_rate_per_post.current_period.string_2f,
                topPosts: page.topPosts.slice(0, 3).map((item) => {
                    return {
                        link: item.link,
                        picture: item.picture,
                    }
                })
            });
        });
    },

    SET_AVERAGE_BENCHMARKS(state) {
        state.competitorBenchmark.competitor_avg.fans = 0;
        state.competitorBenchmark.competitor_avg.posts = 0;
        state.competitorBenchmark.competitor_avg.engagement = 0;

        state.competitorBenchmark.competitors.map((item) => {
            state.competitorBenchmark.competitor_avg.fans += item.fans;
            state.competitorBenchmark.competitor_avg.posts += item.posts;
            state.competitorBenchmark.competitor_avg.engagement += item.engagement;
        });

        let competitor_count = state.competitorBenchmark.competitors.length;

        state.competitorBenchmark.competitor_avg.fans = state.competitorBenchmark.competitor_avg.fans / competitor_count;
        state.competitorBenchmark.competitor_avg.posts = state.competitorBenchmark.competitor_avg.posts / competitor_count;
        state.competitorBenchmark.competitor_avg.engagement = state.competitorBenchmark.competitor_avg.engagement / competitor_count;
    },
}
